import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { PageHeader } from "@/components/Bits";
import api from "@/lib/api";
import { MessageSquare } from "lucide-react";

export default function MessagesHub() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/projects").then((r) => setProjects(r.data)).catch(() => setProjects([])).finally(() => setLoading(false));
  }, []);
  return (
    <Layout>
      <div className="max-w-5xl mx-auto px-6 md:px-10 py-10">
        <PageHeader overline="Communications" title="Project messages" description="Replaces WhatsApp. Every message stays on the project record." />
        {loading ? <div className="overline">Loading…</div> : projects.length === 0 ? (
          <div className="bq-card p-10 text-center"><MessageSquare size={24} className="mx-auto text-[var(--bq-text-muted)]" /><div className="overline mt-3">No projects to message about</div></div>
        ) : (
          <div className="bq-card divide-y divide-[var(--bq-border)]">
            {projects.map((p) => (
              <Link key={p.id} to={`/projects/${p.id}`} className="flex items-center justify-between px-6 py-4 hover:bg-[var(--bq-bg)] transition-all" data-testid={`message-thread-${p.id}`}>
                <div>
                  <div className="font-semibold">{p.title}</div>
                  <div className="text-xs text-[var(--bq-text-muted)]">{p.customer_name} · {p.address}</div>
                </div>
                <span className="text-[var(--bq-orange)] font-semibold text-sm">Open chat →</span>
              </Link>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
